import "./i18n";
import "./Polyfills";
import * as Sentry from "@sentry/react";
import * as Apollo from "./Apollo";
import React, { ReactElement, Suspense, useEffect } from "react";
import styled, { createGlobalStyle, css, ThemeProvider } from "styled-components";
import { absoluteCentre, defaultTheme, margin } from "./common/styles";
import { BookingToolData } from "./BookingToolData";
import { LoadingSpinnerSvg as BaseLoadingSpinnerSvg } from "./common/components";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GenericBookingToolData } from "./GenericBookingToolData";
import RootContainer from "./RootContainer";
import { loadSquareScript } from "./utils";
export const apolloClient = Apollo.createClient();
const urlParams = new URLSearchParams(window.location.search);
const inPopoverMode = !!urlParams.get("inPopoverMode");
export function App(): ReactElement {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id") ?? "";
  const organisationId = urlParams.get("organisationId") ?? "";
  const iFrameId = urlParams.get("iFrameId") ?? undefined;
  Sentry.setTags({
    "booking-tool.id": id ? id : "undefined",
    "iframe.id": iFrameId ? iFrameId : "undefined",
    "organisation.id": organisationId ? organisationId : "undefined"
  });
  return <ThemeProvider theme={defaultTheme} data-sentry-element="ThemeProvider" data-sentry-component="App" data-sentry-source-file="App.tsx">
      {/* Cannot translate spinner title as it shows while translations are loading */}
      <Suspense fallback={<LoadingSpinnerSvg title="loading" />} data-sentry-element="Suspense" data-sentry-source-file="App.tsx">
        <GlobalStyle data-sentry-element="GlobalStyle" data-sentry-source-file="App.tsx" />
        <Apollo.ApolloProvider client={apolloClient} data-sentry-element="unknown" data-sentry-source-file="App.tsx">
          <RootContainer inPopoverMode={inPopoverMode} data-sentry-element="RootContainer" data-sentry-source-file="App.tsx">
            <AppContainer inPopoverMode={inPopoverMode} data-sentry-element="AppContainer" data-sentry-source-file="App.tsx">
              {id && <BookingToolData inPopoverMode={inPopoverMode} />}
              {!id && organisationId && <GenericBookingToolData inPopoverMode={inPopoverMode} />}
            </AppContainer>
          </RootContainer>
        </Apollo.ApolloProvider>
      </Suspense>
    </ThemeProvider>;
}
const LoadingSpinnerSvg = styled(BaseLoadingSpinnerSvg)`
  ${absoluteCentre}
`;
const GlobalStyle = createGlobalStyle`
  html {
    font-size: 100%;  // 16px in most default cases
    -webkit-text-size-adjust: 100%;
  }

  :root {
    box-sizing: border-box;
    font-family: Lato;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html, body, #main {
    ${margin.zero}
  }

`;
const popoverStyles = inPopoverMode ? css`
      ${absoluteCentre}

      @media screen and (width >= 800px) {
        width: 800px;
        max-height: 640px;
      }
      @media screen and (width >= 1200px) {
        width: 1072px;
        max-height: 800px;
      }
    ` : null;
const AppContainer = styled.div<{
  inPopoverMode: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: visible;

  ${popoverStyles};

  background-color: #ffffff;
`;
export default App;